import React, { useCallback, useEffect, useRef, useState } from "react";
import CustomerDetails from "../components/CustomerDetails";
import CustomerList from "../components/CustomerList";
import Card from "../ui/Card";
import Nav from "../ui/Nav";
import Space from "../ui/Space";
import { pubCall, pubCallAsync } from "../utils/PubSub";
import { ROUTES } from "../utils/Routes";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import { showError, showMessage } from "../ui/Message";
import { CUSTOMER } from "../utils/Struct";
import CustomerHistory from "../components/CustomerHistory";
import CustomersSearch from "../popups/CustomersSearch";
import { createModal } from "../hooks/createModal";
import Checkbox from "../ui/Checkbox";
import Tabs from "../ui/Tabs";
import { ENUMS } from "../utils/Enums";
import { drawPicker } from "../popovers/Picker";
import Cookies from "js-cookie";
import CustomerAR from "../components/CustomerAR";
import { kbdEvent, requestPrompt } from "../utils/Utils";
import Confirm from "../popups/Confirm";
import InventoryDetails from "../components/InventoryDetails";
import HistoryFilters from "../popups/HistoryFilters";
import CustomerMessage from "../popups/CustomerMessage";
import CustomerExtra from "../popups/CustomerExtra";
import CustomerPrint from "../popups/CustomerPrint";
import CustomerFilters from "../components/CustomerFilters";
import CustomerAlert from "../popups/CustomerAlert";
import CustomerAddress from "../components/CustomerAddress";
import ReportsCustomerList from "../components/ReportsCustomerList";
import ReportsInventorySearch from "../components/ReportsInventorySearch";

export const cust_createType = ({ type = "", desc = "" }, callback = () => { }, async = false) => {
    let _obj = { type: type, desc: desc }
    const endpoint = "customer_type.create";
    if (async) {
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const cust_editType = ({ type = "", desc = "", customer_type = "" }, callback = () => { }, async = false) => {
    let _obj = { new_type: type, new_desc: desc, old_customer_type: customer_type }
    const endpoint = "customer_type.edit";
    if (async) {
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const cust_deleteType = ({ customer_type = "" }, callback = () => { }, async = false) => {
    let _obj = { customer_type: customer_type }
    const endpoint = "customer_type.remove";
    if (async) {
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export default function CustomersController(props) {

    const { controller = "", is_modal = false, signal = {}, search = "", report = {}, isFilterPage = false, initData = false, newCustomer = false, callback = () => { }, setController = () => { }, route = ROUTES.CUSTOMER.CUSTOMER } = props;
    //ship_to is the unique id
    const [selected, setSelected] = useState((initData?.rows?.[0]) ? initData?.rows?.[0] : {});
    const [filters, setFilters] = useState({ limit: 40, sort: "name", dynamic: (is_modal) ? false : true }) // bill_to, name, san, ship_to
    const [fullData, setFullData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState((initData && Array.isArray(initData?.rows)) ? [...initData?.rows] : []);
    const [align, setAlign] = useState("auto");
    const [reportSearch, setReportSearch] = useState("");
    const [searchMsg, setSearchMsg] = useState((!is_modal) ? "Search results" : "");
    const [goto, setGoto] = useState(false)

    
    const [state, setState] = useState({
        view: "customers",
        edit: false,
        new: false,
        copy: false,
        search: (initData) ? <><span style={{"color" : "var(--text-light)"}}>Search results: <span style={{"color" : "var(--text)"}}>{initData?.total}</span> matches using keyword: <em style={{"color" : "var(--text-yellow)"}}>"{search}"</em></span></> : "",
        tabs: "history",
        history_checked: false,
    })

    const default_filters = {
        //only_recent: false,
        a_r: true,
        orders: true,
        prepay: true,
        quotes: false,
        invoices: false,
        held : false,
        sales: true,
    }

    // Customer Inventory
    const [inventoryData, setInventoryData] = useState({});
    const [historyFilters, setHistoryFilters] = useState(default_filters);

    const onHistorySelect = (_history_item) => {
        if(!_history_item?.primary_code) return; 
        pubCall("stock.getSingleByCode", { primary_code: _history_item.primary_code, condition_code : _history_item.condition_code }, (_s, _r) => {
            setInventoryData(_r);
        })
    }

    const [hasAlert, setHasAlert] = useState(false);

    useEffect(() => {
        setHasAlert(selected?.alert_message ? true : false);
    }, [selected]);

    useEffect(() => {
        if (hasAlert && !state.edit && !state.new) {
            window.bm_state.value = ROUTES.CUSTOMER.ALERTS;
            createModal({
                component: <CustomerAlert 
                    controller={controller} 
                    signal={signal}
                    updateRow={updateRow} 
                    route={ROUTES.CUSTOMER.ALERTS} 
                    selected={selected} 
                    edit={false} 
                />, 
                closable: true, 
                title: "Customer Alert", 
                callback: (action) => { 
                    if (action === "edit") {
                        editAlert();
                    } else {
                        window.bm_state.value = route;
                    }
                    
                },
            });
        } 
    }, [hasAlert]);

    const showReportSearch = () => {
        window.bm_state.value = ROUTES.REPORTS.SEARCH;
        createModal({
            component: <ReportsInventorySearch setReportSearch={setReportSearch} controller={controller} route={ROUTES.REPORTS.SEARCH} />, closable: true, title: "Search",
            callback: (e) => {
                window.bm_state.value = route
            }
        });
    }

    const searchCustomer = () => {

        if (!is_modal || !search) {
            return;
        }
        setLoading(true);
        pubCall("customer.searchKeyword", { search_term: search, limit: 45 }, (_s, _r) => {
            if (_s) {

                setData(_r.rows);
                if (_r?.rows?.length > 0) {
                    setSelected(_r.rows[0]);
                }
            }
            setLoading(false)
        })
    }

    useEffect(searchCustomer, []);


    const loadNewCustomer = () => {
        if (!newCustomer) {
            return;
        }
        switchNew();
    }

    useEffect(loadNewCustomer, [])

    const switchEdit = () => {

        setState(prevState => {
            if (!prevState.edit) {
                window.bm_state.value = ROUTES.CUSTOMER.EDIT;
            } else {
                window.bm_state.value = route;
            }
            return {
                ...prevState,
                edit: !prevState.edit,
                new: false,
                copy: false
            };
        });
    };

    const switchNew = () => {
        setState(prevState => {
            if (!prevState.new) {
                window.bm_state.value = ROUTES.CUSTOMER.EDIT;
            } else {
                window.bm_state.value = route;
            }
            return {
                ...prevState,
                edit: !prevState.edit,
                new: !prevState.new
            };
        });
    };

    const selectedRef = useRef(selected);
    const timeoutRef = useRef(null);
    const pendingRef = useRef(null);
    const lastRunRef = useRef(null);

    const runFetch = useCallback((_selected) => {
        if (!_selected?.ship_to) {
            return;
        }
        pubCall("customer.getInfo", { ship_to: _selected.ship_to }, (_s, _r) => {
            if (_s) {
                setFullData(_r);
            } else {
                showError(_r);
            }
        });
    }, []);

    const fetchExtra = useCallback((_selected = selected) => {

        selectedRef.current = _selected;

        if (_selected?.ship_to) {
            Cookies.set("customer_ship_to", _selected.ship_to);
        }
        if(!timeoutRef.current){
            runFetch(_selected);
            lastRunRef.current = _selected;
        }
        pendingRef.current = _selected;
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            const toRun = pendingRef.current;
            if (toRun && toRun.ship_to !== lastRunRef.current?.ship_to) {
                runFetch(toRun);
                lastRunRef.current = toRun;
            }
            timeoutRef.current = null;
            pendingRef.current = null;
        }, 300);
    }, [selected, runFetch]);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);



    useEffect(fetchExtra, [selected]);


    const deleteRow = () => {
        window.bm_state.value = ROUTES.HELPERS.CONFIRM;
        createModal({
            alert: true,
            component: <Confirm controller={controller} events={[KBD.D, KBD.U]} title={"Delete this customer's account?"} signal={signal} route={ROUTES.HELPERS.CONFIRM} />, closable: true, callback: (e) => {
                window.bm_state.value = route;
                if (e) {
                    pubCall("customer.remove", { ship_to: selected.ship_to }, (_s, _r) => {
                        if (_s) {
                            let _f = data.findIndex(item => item.ship_to === selected.ship_to);
                            if (data.length > _f - 1) { setSelected(data[_f + 1]); }
                            else if (data.length > 0) { setSelected(data[_f - 1]); }
                            else { setSelected({}) }

                            setData(data.filter(item => item.ship_to !== selected.ship_to));
                        } else {
                            showError(_r);
                        }
                    })
                }
            }
        })
    }

    const showHistoryFilters = () => {
        window.bm_state.value = ROUTES.HISTORY.FILTERS;
        createModal({
            component: <HistoryFilters controller={controller} filters={historyFilters} route={ROUTES.HISTORY.FILTERS} />, closable: true, title: <>History Filters</>, callback: (_filter) => {
                if (_filter) {
                    setHistoryFilters({ ..._filter });
                    switchView("history");
                } else {
                    window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
                }
            }
        });
    }

    const showGoto = () => {
        requestPrompt({
            route: route, width: 0, title: "Go to Record #", inputProps: { number: true, style: { "textAlign": "left" }, width: 100 }, width: 182, callback: (e) => {
                if (e) {
                    setGoto(e)
                }
            }
        })
    }


    const copyEmail = () => {
        if (!selected?.email) {
            return;
        }

        const value = selected["email"];

        navigator.clipboard.writeText(String(value)).then(() => {
            showMessage(value + " copied to the Windows clipboard.");
        }).catch(() => {
            showError("Failed to copy " + value.replace(/_/g, " "));
        });
    };

    const drawIndex = () => {
        drawPicker({
            controller: controller,
            value: filters.sort, title: "Index", closeable: true, height: 300, ref: null, route: route, close: () => { }, callback: (e) => {
                setFilters({ ...filters, "sort": e });
            }, offset: [0, 10],
            options: ENUMS.CUSTOMERS_SORT
        })
    }

    const editAlert = () => {
        window.bm_state.value = ROUTES.CUSTOMER.ALERTS;
        createModal({
            component: <CustomerAlert controller={controller} updateRow={updateRow} route={ROUTES.CUSTOMER.ALERTS} selected={selected} edit={true}/>, closable: true, title: "Alerts", 
            callback: () => { window.bm_state.value = route; 
            },
        });
    }

    const showPrintOptions = () => {
        window.bm_state.value = ROUTES.CUSTOMER.PRINT;
        createModal({
            component: <CustomerPrint signal={signal} route={ROUTES.CUSTOMER.PRINT} selected={selected} />, closable: true, title: "Print Options", 
            callback: (_type) => {
                window.bm_state.value = route;
            }
        });
    }

    const customers_nav = [
        { key: KBD.Digit2, action: () => setController("inventory") },
        { key: KBD.A, text: "A/R", action: () => { switchView("ar") } },
        { text: "Copy" },
        { key: KBD.CTRL_C, text: "Ctrl+Copy", action: () => copyEmail() },
        { disabled: (window.beta), key: KBD.D, text: "Delete", action: () => { deleteRow() } },
        { disabled: (window.beta), key: KBD.E, text: "Edt", action: () => { switchEdit() } },
        { disabled: (window.beta), key: KBD.F, text: "Filter", action: () => { switchView("filters") } },
        { key: KBD.H, text: "History", action: () => showHistoryFilters() },
        { key: KBD.I, text: "Index", action: drawIndex },
        { text: "Kard" },
        { text: "Label" },
        { key: KBD.M, text: "Message", action: () => showMessageNote() },
        ...(window.beta ? [{text: "New"}] : [{ key: KBD.N, text: "New", action: () => { switchNew() } }]),
        { key: KBD.P, text: "Print", action: () => showPrintOptions() },
        { key: KBD.S, text: "Search", action: () => showSearch() },
        { key: KBD.V, text: "View", action: () => switchView("history") },
        { disabled: (window.beta), key: KBD.X, text: "Xtra", action: () => (window.beta) ? "" : showExtra() },
        { key: KBD.ARROW_RIGHT, action: () => switchView("history") },
        { key: KBD.ESCAPE, action: () => { (is_modal) ? callback() : setController("home") } },
        { key: KBD.ALT_E, action: () => editAlert() },
        {
            key: KBD.ENTER, action: () => {
                if (is_modal) {
                    callback(selected)
                }
            }
        }
    ]


    useEffect(() => {
        if (state.view === "filters") { return; }
        const cleanup = listen(controller, route, customers_nav);
        return cleanup;
    }, [customers_nav, state]);

    useEffect(() => {
        if (newCustomer) {
            return;
        }
        window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER
    }, []);

    const [longNote, setLongNote] = useState([]);

    const getNotes = () => { 
        pubCall("customer.getNote", { ship_to: selected.ship_to }, (_s, _r) => {
            if (_s) {
                setLongNote(_r);
            }
        });
    }

    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            getNotes();
        }, 300);

        return () => clearTimeout(debounceTimer);
    }, [selected])

    const CustomerNotes = (props) => {

        const { notes = [] } = props;

        return (
            <Card secondary header={<Label style={{ "textAlign": "left" }}>Customer Notes</Label>}>
                <div style={{ "height": "calc(100vh - 470px)", "width": "277px", "display": "flex", "alignItems": "center", "justifyContent": "center" }}>
                    <div style={{ "width": "290px", "height": "calc(100vh - 470px)", "overflowY": "auto" }}>
                        <Label style={{ "textAlign": notes.some(note => note.trim()) ? "left" : "center", "color": "var(--text-light)" }}>
                            {(notes.length > 0 && notes.map((note, index) => (
                                <div key={index} style={{ wordWrap: "break-word", overflowWrap: "break-word", marginBottom: "2px" }}>{note}</div>
                            )))}
                            {((notes.length === 0 || !notes.some(note => note.trim())) && <em>Press <strong><u><span style={{ "fontStyle": "normal", "fontWeight": "800", "color": "var(--text-light)" }}>M</span></u></strong>essage to add longform notes.</em>)}
                        </Label>
                    </div>
                </div>
            </Card>
        )
    }


    const showSearch = () => {
        window.bm_state.value = ROUTES.CUSTOMER.SEARCH;
        createModal({
            component: <CustomersSearch state={state} setState={setState} signal={signal} setStock={setSelected} selected={selected} route={ROUTES.CUSTOMER.SEARCH} />, closable: true, title: "Customer Search",
            callback: (_r) => {
                if (_r) {
                    setAlign("start");
                    if (_r.dynamic) {
                        setFilters({ ...filters, "dynamic": true })
                        setData(_r.results.rows_previous.concat(_r.results.rows_next));
                        setSelected((_r.results.rows_next.length > 0) ? _r.results.rows_next[0] : {})
                    } else {
                        setFilters({ ...filters, "dynamic": false })
                        setData(_r.results.rows);
                        if (_r.results?.rows?.length > 0) {
                            setSelected(_r.results.rows[0]);
                        }
                    }
                }
                window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER
            }
        });
    }

    const switchView = (_state = "customers") => {

        let _tab = state.tabs;

        switch (_state) {
            case "customers":
                window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
                break;
            case "history":
                _tab = "history";
                window.bm_state.value = ROUTES.CUSTOMER.HISTORY;
                break;
            case "ar":
                window.bm_state.value = ROUTES.CUSTOMER.AR;
                break;
            case "filters":
                window.bm_state.value = ROUTES.CUSTOMER.FILTERS;
                break;
        }

        setState({ ...state, "view": _state, "tabs": _tab })
    };

    const showMessageNote = () => {
        window.bm_state.value = ROUTES.CUSTOMER.MESSAGES;
        createModal({ component: <CustomerMessage controller={controller} setLongNote={setLongNote} ship_to={selected?.ship_to} route={ROUTES.CUSTOMER.MESSAGES} /> , closable: true, callback: () => { window.bm_state.value = route; }, title: "Customer Notes" })
    }

    const editAddress = () => {

        window.bm_state.value = ROUTES.CUSTOMER.ADDRESS;
        createModal({
            title: "Customer Shipping Addresses",
            component: <CustomerAddress customer={selected} controller={controller} route={ROUTES.CUSTOMER.ADDRESS} />,
            closable: true,
            callback: (e) => {
                if (e) {
                    // do something with the address
                }
                window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
            }
        })
    }


    const toggleHistory = () => {
        setState(prev => ({
            ...prev,
            history_checked: !prev.history_checked
        }));
    };

    const handleTabChange = (tabId) => {
        let _view = state.view;
        if (tabId === "notes" && window.bm_state.value === ROUTES.CUSTOMER.HISTORY) {
            setState(prev => ({ ...prev, tabs: "notes", view: "customers" }));
            window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
        }
        else {
            setState(prev => ({ ...prev, tabs: tabId, view: _view }));
        }
    };

    const updateRow = (_data, _ship_to) => {
        let _d = [...data];
        let _f = _d.findIndex(item => item.ship_to === _ship_to);
        if (_f > -1) {
            _d[_f] = _data;
            setData(_d);
            setSelected(_data);
        }
        
    }

    const getCustomerData = () => {

        if (state.new) {

            if (state.copy) {
                return { ...selected, ship_to: "" };
            }

            return { ...CUSTOMER, name: newCustomer?.name || "", phone: newCustomer?.phone || "" }
        }

        if (fullData?.ship_to === selected?.ship_to) {
            return { ...fullData };
        }
        
        if (fullData?.ship_to && selected?.ship_to) {
            return { ...fullData };
        }
        
        if (selected) {
            return { ...selected };
        }
    }



    const tabData = [
        { id: "history", label: <><Checkbox value={state.history_checked} onChange={toggleHistory}>&nbsp;</Checkbox>History</>, content: <></> },
        { id: "notes", label: <>Notes</>, content: <></> },
    ];

    const showExtra = () => {
        window.bm_state.value = ROUTES.CUSTOMER.EXTRA;
        createModal({
            component: <CustomerExtra signal={signal} route={ROUTES.CUSTOMER.EXTRA} />, closable: true, title: "Xtra Options",
            callback: (_type) => {
                if (_type === "A") {
                    editAlert();
                } else if (_type === "S") {
                    editAddress();
                } else {
                    window.bm_state.value = route;
                }
            }
        });
    }

    const drawExtra = () => {


        if (state.view === "reserve") {
            return (<></>)
        }

        const { tabs, history_checked } = state;

        const _history = <CustomerHistory onHistorySelect={onHistorySelect} controller={controller} view={state.view} route={ROUTES.CUSTOMER.HISTORY} switchView={switchView} selected={selected} filters={historyFilters} setFilters={setHistoryFilters} />;
        // Determine what goes in the right panel
        let rightContent = null;
        if (tabs === "history") {
            rightContent = _history;
        } else if (tabs === "notes") {
            rightContent = <><CustomerNotes notes={longNote} /></>;
        } else if (tabs === "peers") {
            rightContent = <>Peers</>;
        }

        const showLeftHistory = tabs !== "history" && history_checked;


        return (
            <Space
                grow
                style={{ alignItems: "flex-start", padding: "0px 0px" }}
                size={0}
            >
                {(showLeftHistory) && <div style={{ flex: 1, "marginRight": "15px" }}>
                    {showLeftHistory ? _history : null}
                </div>}

                <div style={{ flex: 3 }}>
                    <Tabs
                        selected={state.tabs}
                        onChange={handleTabChange}
                        show_content={false}
                        indent
                        style={{ marginTop: "-22px" }}
                        content_class=""
                        border={false}
                        tabData={tabData}
                    />
                    {rightContent}
                </div>
            </Space>
        )
    }

    const filterLocal = (_data, _filters = filters) => {

        if (_filters.dynamic) {
            return _data;
        } else {
            let _s = _filters.localSort;
            return _data.sort((a, b) => {
                if (a[_s] < b[_s]) {
                    return -1;
                }
                if (a[_s] > b[_s]) {
                    return 1;
                }
                return 0;
            })
        }
    }

    return (<>


        <div className="controller">

            {state.view !== "history" && state.view !== "filters" &&
                <CustomerDetails
                    controller={controller}
                    selected={getCustomerData()}
                    setSelected={setSelected}
                    route={ROUTES.CUSTOMER.DETAILS}
                    switchEdit={switchEdit}
                    signal={signal}
                    updateRow={updateRow}
                    isnew={state.new}
                    edit={state.edit}
                    setData={setData}
                    editAddress={editAddress}
                    callback={(customer) => {
                        if (newCustomer) {
                            callback(customer);
                        }
                    }}
                // state={state}
                // setState={setState}
                // in_stock={in_stock}
                // isTitleLink={isTitleLink}
                // stock_data={getStockData()}
                />
            }
            {state.view === "history" && state.view !== "filters" &&
                <InventoryDetails
                    controller={controller}
                    state={state}
                    // gridLoading={gridLoading} 
                    setState={setState}
                    setSelected={setSelected}
                    stock_data={inventoryData || {}}
                    // gridType={gridType} 
                    // monthly_sold={fullData?.monthly_sold} 
                    // grid_info={fullData?.grid_info} 
                    signal={signal}
                    in_stock={true} 
                    setData={setData}
                    // isTitleLink={isTitleLink} 
                    updateRow={updateRow}
                    switchEdit={switchEdit}
                    isnew={state.new}
                    edit={state.edit}
                />
            }

            <div>
                <div>
                    <div className="shim" />


                    {/* const {data = [], selected = {}, setSelected = () => { }, loading = false, setLoading = () => { }, align = "auto", setAlign = () => { }, route = ""} = props; */}


                    {(state.view === "ar" && <>
                        <CustomerAR controller={controller} switchView={switchView} selected={selected} drawExtra={drawExtra} route={ROUTES.CUSTOMER.AR} />
                    </>)}

                    {(state.view === "filters" && <>
                        <CustomerFilters controller={controller} signal={signal} switchView={switchView} route={ROUTES.CUSTOMER.FILTERS} callback={() => {}}/>
                    </>)}

                    {((state.view === "customers" || state.view === "history") &&
                        <>
                            <Space style={{ "padding": "5px 20px" }}>
                                <Label>{state.search}&nbsp;</Label>
                            </Space>

                            <Space grow style={{ "alignItems": "flex-start", "padding": "0px 15px" }} size={15}>
                                
                                {(is_modal && isFilterPage) ? (
                                    <ReportsCustomerList
                                        hide={(state?.tabs === "read-only" || state?.view === "orders" || state?.view === "order")}
                                        reportSearch={reportSearch}
                                        controller={controller}
                                        header={<>{searchMsg}</>}
                                        report={report}
                                        onSelectedRowClick={() => {
                                            if (state?.view === "inventory" || state?.view === "inventory_full") {
                                                kbdEvent(KBD.ENTER)
                                            }
                                        }}
                                        switchView={switchView}
                                        selected={selected}
                                        setSelected={setSelected}
                                        route={route}
                                        state={state}
                                        setState={setState}
                                        fullData={fullData}
                                        goto={goto}
                                    />
                                ) : (
                                    <CustomerList
                                        onDoubleClick={() => kbdEvent(KBD.ENTER)}
                                        controller={controller}
                                        filterLocal={filterLocal}
                                        signal={signal}
                                        view={state.view}
                                        align={align}
                                        setAlign={setAlign}
                                        selected={selected}
                                        setSelected={setSelected}
                                        loading={loading}
                                        setLoading={setLoading}
                                        data={data}
                                        setData={setData}
                                        filters={filters}
                                        setFilters={setFilters}
                                        route={route}
                                        state={state}
                                    />
                                )}
                                {drawExtra()}
                            </Space>
                        </>
                    )}
                </div>
            </div>
            <div className="shim" />
            <Divider />
            <div style={{ 'height': "30px" }}>
                {(state.view === "customers" &&
                    <Space style={{ "padding": "0px 15px" }}>
                        <Nav nav={customers_nav} />
                    </Space>
                )}
            </div>
        </div>


    </>)

}


